import type { FaireProductEntity } from "../../entity_types/product";

export const p_myfrpzf6mp: FaireProductEntity = {
  token: "p_myfrpzf6mp",
  type: "product",
  name: "BRAIN FOODS Gluten Free Vegan Oat Bars (Blueberry)",
  brandToken: "b_46hn96hpk5",
  brandName: "Wilton Mettler LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/c862b3cb981d1b5cfcfc6d5a1eac7d15d7265f4821e78f065a55403ba939e532.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9fa82eafc1299beff84d3a1ee935ab3216930501432a91482b715a1d4b3691cf.jpeg",
    "https://cdn.faire.com/fastly/e29d39d4829e52565a522729dd0a464e359911032db69a28ac72c53c6fc4a7f5.jpeg",
  ],
  priceDollars: 2.91,
  description:
    "Enjoy the snack that’s super popular in England and now making its debut in the US! BRAIN FOODS Blueberry Oat Bars combine wholesome gluten-free oats with the sweet-tart flavor of real blueberries, delivering a satisfying and nutritious snack. These bars are vegan, gluten free, and contain no added sugar or palm oil, making them a smarter choice for indulgence without compromise. Packed with healthy fats, fiber, and protein, they provide sustained energy and are hearty enough to serve as a meal replacement when needed. Individually packed for on-the-go convenience, they’re perfect for work, travel, workouts, or anytime you want a fruity, satisfying snack.\n\nNutrition Facts: Serving size 1 bar (70g). Calories 320. Total Fat 14g (18% Daily Value), Saturated Fat 5.6g (28% DV), Trans Fat 0g, Cholesterol 0mg (0% DV), Sodium 140mg (6% DV), Total Carbohydrates 36g (13% DV), Dietary Fiber 2.5g (9% DV), Total Sugars 1.5g, Includes 0g Added Sugars (0% DV), Sugar Alcohols 7.1g, Protein 5.7g (11% DV). Vitamin D 0mcg (0% DV), Calcium 0mg (0% DV), Iron 0mg (0% DV), Potassium 0mg (0% DV). Percent Daily Values are based on a 2,000 calorie diet. Keep in a dry and cool place. Batch / Best before: see the package.\n\n\n",
  tags: [],
  msrpDollars: 5.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:58.006Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
